import React from 'react';

const getLearningTypeLabel = type => {
  return type === 'zoom' ? 'Online' : 'In Person';
};

export default getLearningTypeLabel;
